import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Card, Col, Form, Modal, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import Loader from '../../../App/layout/Loader';
import { useSelector } from '../../../store/reducer';
import { getIpAddress } from '../../../store/propertyMaster/propertyMaster.actions';
import { useDispatch } from 'react-redux';
import { PROPERTY_MASTER } from '../../../store/propertyMaster/propertyMaster.reducer';
import {
    CREATE_AND_CLOSE_BUTTON,
    DELETE_BUTTON,
    FEEDBACK_MODAL_OPEN,
    LOADING_MODAL_OPEN,
    MODAL_CLOSE,
    MODAL_OPEN,
    PROPERTY_MODAL_OPEN,
    UPDATE_BUTTON
} from '../../../store/actions';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { jsPDF } from 'jspdf';
import DataGrid, {
    Paging,
    Scrolling,
    Pager,
    SearchPanel,
    FilterRow,
    HeaderFilter,
    Column,
    ColumnChooser,
    ColumnFixing,
    FilterPanel,
    Button as ActionButton,
    Export,
    Selection,
    Summary,
    TotalItem
} from 'devextreme-react/data-grid';
import CommonFeedbackModal from '../../../App/components/CommonFeedbackModal';
import { fetchStyleMaster } from '../../../store/styleMaster/styleMaster.actions';
import { YARN_PO_DETAILS } from '../../../store/programs/YarnPO/yarnPODetails/yarnPODetails.reducer';


import { NAVIGATE_YARN_PO } from '../../../store/programs/YarnPO/yarnPO/yarnPO.actionsType';
import { YARN_PO } from '../../../store/programs/YarnPO/yarnPO/yarnPO.reducer';


import CommonPoDcInwardNoWrapper from '../../../App/components/CommonPoDcInwardNo';
import Config from '../../../config';
import ConstantApi from '../../../ConstantApi';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import axios from 'axios';
import Cookies from 'js-cookie';
import { getCurrentDate } from '../../../App/components/Common/Util';
import VerifyBtn from '../../../App/components/Button/VerifyBtn';
import DeleteConfirmation from '../FabricPo/DeleteConfirmation';
import { COMPACTING_DIVISION_DETAILS } from '../../../store/programs/CompactingDivisonDC/compactingDivisionDetails/compactingDivisionDetails.reducer';
import { COMPACTING_AUTHORIZATION } from '../../../store/programs/CompactingDivisionAuthorization/compactingDivAuthorization.reducer';
import { COMPACTING_DIVISION_AUTHORIZED_BTN, COMPACTING_DIVISION_AUTHORIZE_USERFORM_RESET, NAVIGATE_COMPACTING_DIV_AUTHORIZATION } from '../../../store/programs/CompactingDivisionAuthorization/compactingDivAuthorization.actionsType';
import { fetchCompactingDCDetailsById } from '../../../store/programs/CompactingDivisonDC/compactingDivisionDetails/compactingDivisionDetails.actions';
import { UpdateCompactingAuthorizeVerify, fetchCompactingDivAuthDetailData } from '../../../store/programs/CompactingDivisionAuthorization/compactingDivAuthorization.actions';

const componentId = 'yarnPODetailsFeedback';

const CompactingDivAuthDetailsComp = () => {
    let dispatch = useDispatch();
    const [authorizeclick, setAuthorizeclick] = useState(false);
    //const [triggerStatus, setTriggerStatus] = useState(false);

    let { yarnPODetailsById, loading, userform } = useSelector((state) => {
        return state[YARN_PO_DETAILS];
    });
    let { compactingDCDetailsById } = useSelector((state) => {
        return state[COMPACTING_DIVISION_DETAILS];
    });
    let { compactingDivAuthSelectedvalue, compactingAuthDetailsData, verifyCompacting, Authreset } = useSelector((state) => {
        return state[COMPACTING_AUTHORIZATION];
    });
    let { isFormModal, buttonStatus, isLoaderModal } = useSelector((state) => {
        return state.able;
    });



    // companyMaster and ip address API call





    const exportFormats = ['xlsx', 'pdf'];
    const propertyModal = () => {
        dispatch({ type: PROPERTY_MODAL_OPEN, id: componentId });
    };

    useEffect(() => {
        dispatch(fetchCompactingDivAuthDetailData(compactingDivAuthSelectedvalue?.fldId));
        // dispatch(getIpAddress());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);


    useEffect(() => {
        if (verifyCompacting === 200) {
            setAuthorizeclick(true);
        }

    }, [verifyCompacting])

    const authorizeit = () => {
        dispatch({ type: LOADING_MODAL_OPEN });
        dispatch(UpdateCompactingAuthorizeVerify(compactingDivAuthSelectedvalue?.fldId, true))

    }

    const onExporting = useCallback((e) => {
        if (e.format === 'xlsx') {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet('Compacting');
            exportDataGrid({
                component: e.component,
                worksheet,
                autoFilterEnabled: true
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Companies.xlsx');
                });
            });
            e.cancel = true;
        } else if (e.format === 'pdf') {
            const doc = new jsPDF();
            exportDataGridToPdf({
                jsPDFDocument: doc,
                component: e.component
            }).then(() => {
                doc.save('Compacting.pdf');
            });
        }
    });
    const allowedPageSizes = [10, 20, 50, 100];
    const renderTitleHeader = (data) => {
        return <div style={{ fontWeight: 'bold' }}>{data.column.caption}</div>;
    };
    console.log("compactingDivAuthSelectedvalue", compactingDivAuthSelectedvalue)
    useEffect(() => {
        if (isLoaderModal) {
            return Swal.fire({
                html: `
              <div class="custom-loader-container">
                <div class="custom-loader"></div>
                <div class="custom-loader"></div>
                <div class="custom-loader"></div>
                <div class="custom-loader"></div>
                <p class="loading-text">Processing Please Wait...</p>
              </div>
            `,
                text: 'Please Wait...',
                allowOutsideClick: false,
                showConfirmButton: false,
                customClass: {
                    popup: 'custom-popup'
                }
            });
        } else {
            Swal.close();
        }
    }, [isLoaderModal]);



    return (
        <Row className="d-flex flex-column">
            {loading && <Loader />}

            <CommonFeedbackModal id={componentId} />
            <Col>




                <Card>
                    <Card.Header>
                        <Card.Title style={{ color: 'blue', fontWeight: 'bold', display: 'flex', justifyContent: 'center' }} as="h5">
                            <span>Compacting Receiving Details of {compactingDivAuthSelectedvalue?.fldSupplierName}</span>
                            <span style={{ margin: '0 auto', marginLeft: '27%' }}>
                                <CommonPoDcInwardNoWrapper title="PO No" value={compactingDivAuthSelectedvalue?.fldGRNNo} />
                            </span>
                        </Card.Title>
                        <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Col>
                                <Button
                                    onClick={() => {
                                        dispatch({ type: NAVIGATE_COMPACTING_DIV_AUTHORIZATION });
                                        dispatch({ type: COMPACTING_DIVISION_AUTHORIZE_USERFORM_RESET });
                                    }}
                                    variant="primary"
                                    size="sm"
                                >
                                    BACK
                                </Button>
                            </Col>
                            <Col className="col-1">
                                {!authorizeclick ?
                                    <Button
                                        onClick={authorizeit}
                                        variant="primary"
                                        size="sm"

                                        style={{ backgroundColor: '#486b300', borderColor: '#486b300' }}
                                    >
                                        Authorize
                                    </Button> : <Button
                                        //onClick={authorizeit}
                                        variant="primary"
                                        size="sm"
                                        style={{ backgroundColor: '#86b300', borderColor: '#86b300' }}
                                        disabled
                                    >
                                        Authorized
                                    </Button>}

                            </Col>
                        </Row>

                    </Card.Header>
                    <Card.Body>
                        <DataGrid
                            dataSource={compactingAuthDetailsData}
                            keyExpr="fldId"
                            showBorders={true}
                            columnAutoWidth={true}
                            allowColumnReordering={true}
                            allowColumnResizing={true}
                            columnResizingMode="widget"
                            rowAlternationEnabled={true}
                            onExporting={onExporting}
                            hoverStateEnabled={true}
                        >
                            <FilterRow visible={true} applyFilter="auto" />
                            <FilterPanel visible={true} />
                            <HeaderFilter visible={true} />
                            <SearchPanel visible={true} width={240} placeholder="Search..." />
                            <ColumnChooser enabled={true} />
                            <ColumnFixing enabled={true} />
                            <Scrolling rowRenderingMode="virtual"></Scrolling>
                            <Paging defaultPageSize={10} />
                            <Pager
                                visible={true}
                                showPageSizeSelector={true}
                                allowedPageSizes={allowedPageSizes}
                                showNavigationButtons={true}
                                showInfo={true}
                                infoText="Page #{0}. Total: {1} ({2} items)"
                            />
                            <Column headerCellRender={renderTitleHeader} dataField="fldStyleNumber" caption="Style Number"></Column>
                            {/* <Column headerCellRender={renderTitleHeader} dataField="fldSalesOrderNo" caption="Sales Order No"></Column> */}
                            <Column headerCellRender={renderTitleHeader} dataField="fldFabricGroup" caption="Fabric Group"></Column>
                            <Column headerCellRender={renderTitleHeader} dataField="fldFabricname" caption="Fabric"></Column>
                            <Column headerCellRender={renderTitleHeader} dataField="fldYarnCounts" caption="Yarn Count"></Column>
                            <Column headerCellRender={renderTitleHeader} dataField="fldColourShade" caption="Color Shade"></Column>
                            <Column headerCellRender={renderTitleHeader} dataField="fldBCDia" caption="BC Dia"></Column>
                            <Column headerCellRender={renderTitleHeader} dataField="fldBCGSM" caption="BC GSM"></Column>
                            <Column headerCellRender={renderTitleHeader} dataField="fldACDia" caption="AC Dia"></Column>
                            <Column headerCellRender={renderTitleHeader} dataField="fldACGSM" caption="AC GSM"></Column>
                            <Column headerCellRender={renderTitleHeader} dataField="fldGSM" caption="GSM"></Column>
                            <Column headerCellRender={renderTitleHeader} dataField="fldFKNoofRolls" caption="NO. Of Rolls"></Column>
                            <Column headerCellRender={renderTitleHeader} dataField="fldQuantity" caption="Total Weight"></Column>
                            <Column headerCellRender={renderTitleHeader} dataField="fldInwardDia" caption="Inward Dia"></Column>
                            <Column headerCellRender={renderTitleHeader} dataField="fldRequiredDia" caption="Required Dia"></Column>
                            <Column headerCellRender={renderTitleHeader} dataField="tblHSNCode.fldSalesCode" caption="HSN code"></Column>
                            <Column headerCellRender={renderTitleHeader} dataField="tblUOM.fldDescription" caption="UOM"></Column>
                            <Column headerCellRender={renderTitleHeader} dataField="fldColour" caption="Color"></Column>
                            <Column headerCellRender={renderTitleHeader} dataField="fldRemarks" caption="Remarks"></Column>
                            <Summary>
                                <Summary>
                                    <TotalItem column="fldQuantity" summaryType="sum" displayFormat="Total: {0}"
                                        valueFormat="##0.00" />
                                    <TotalItem column="fldFKNoofRolls" summaryType="sum" displayFormat="Total: {0}"
                                        valueFormat="decimal" />
                                </Summary>
                            </Summary>
                            <Export formats={exportFormats} enabled={true} allowExportSelectedData={true} />
                        </DataGrid>
                    </Card.Body>
                </Card>
            </Col>
        </Row >
    );
};

export default CompactingDivAuthDetailsComp;
